var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, } from "@mui/material";
import { getSites } from "../utils/fetchDB"; // Adjust the import path as needed
const Sites = () => {
    const [sites, setSites] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchTrials = () => __awaiter(void 0, void 0, void 0, function* () {
            const data = yield getSites();
            setSites(data);
            setLoading(false);
        });
        fetchTrials();
    }, []);
    if (loading) {
        return React.createElement(CircularProgress, null);
    }
    return (React.createElement("div", null,
        React.createElement("h1", null, "Sites"),
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "ID"),
                    React.createElement(TableCell, null, "Name"),
                    React.createElement(TableCell, null, "Latitude"))),
            React.createElement(TableBody, null, sites.map((site) => (React.createElement(TableRow, { key: site.id },
                React.createElement(TableCell, null, site.id),
                React.createElement(TableCell, null, site.name),
                React.createElement(TableCell, null, site.latitude))))))));
};
export default Sites;
